// src/utils/dateUtil.js

function getTodayYYYYMMDD() {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}${mm}${dd}`;
  }
  
  function formatDate(date, dash) {
    let vDash = dash ? dash : '-';
    if(typeof date === 'string'){
      const yyyy = date.substring(0,4);
      const mm = date.substring(4,6);
      const dd = date.substring(6,8);
      return `${yyyy}${vDash}${mm}${vDash}${dd}`;
    } else {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}${vDash}${mm}${vDash}${dd}`;
    }
  }
  
  // 현재 시:분 (예: "15:30") 구하는 함수
 function getCurrentTime() {
  const now = new Date();
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
}

// 현재 날짜+시간 (예: "2025-04-12 15:30") 구하는 함수
 function getCurrentDateTime() {
  const now = new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, '0'); // getMonth()는 0부터 시작
  const date = now.getDate().toString().padStart(2, '0');
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  
  return `${year}-${month}-${date} ${hours}:${minutes}`;
}

  export default {
    getTodayYYYYMMDD,
    formatDate,
    getCurrentTime,
    getCurrentDateTime
  };
  